import React, { useContext, useState } from "react";
import Img from "../img/img.png";
import Attach from "../img/attach.png";
import { AuthContext } from "../context/AuthContext";
import { ChatContext } from "../context/ChatContext";
import {
  arrayUnion,
  doc,
  serverTimestamp,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { db, storage } from "../firebase";
import { v4 as uuid } from "uuid";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import toast from "react-hot-toast";

const Input = () => {
  const [text, setText] = useState("");
  const [img, setImg] = useState(null);

  const { currentUser, userEventCode } = useContext(AuthContext);
  const { data } = useContext(ChatContext);

  const handleSend = async () => {
    if (data.chatId === "null") {
      toast.error("Please select a chat first");
      return;
    }
    
    if (!text.trim() && !img) {
      toast.error("Please enter a message or select an image");
      return;
    }
    
    const collection = data.isGroupChat ? "groupChats" : "chats";
    
    try {
      if (img) {
        // Check file size (max 10MB)
        if (img.size > 10 * 1024 * 1024) {
          toast.error("Image size must be less than 10MB");
          return;
        }
        
        toast.loading("Uploading image...", { id: "sendMessage" });
        
        const storageRef = ref(storage, uuid());
        const uploadTask = uploadBytesResumable(storageRef, img);

        uploadTask.on(
          (error) => {
            console.error("Upload error:", error);
            toast.error("Failed to upload image. Please try again.", { id: "sendMessage" });
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
              try {
                await updateDoc(doc(db, collection, data.chatId), {
                  messages: arrayUnion({
                    id: uuid(),
                    text,
                    senderId: currentUser.uid,
                    date: Timestamp.now(),
                    img: downloadURL,
                  }),
                });
                
                // Update last message for all participants
                await updateLastMessage(text);
                
                toast.success("Image sent!", { id: "sendMessage" });
                setText("");
                setImg(null);
              } catch (error) {
                console.error("Message send error:", error);
                toast.error("Failed to send message. Please try again.", { id: "sendMessage" });
              }
            });
          }
        );
      } else {
        await updateDoc(doc(db, collection, data.chatId), {
          messages: arrayUnion({
            id: uuid(),
            text,
            senderId: currentUser.uid,
            date: Timestamp.now(),
          }),
        });
        
        // Update last message for all participants
        await updateLastMessage(text);
        
        setText("");
        setImg(null);
      }
    } catch (error) {
      console.error("Send message error:", error);
      toast.error("Failed to send message. Please try again.");
    }
  };

  const updateLastMessage = async (messageText) => {
    try {
      const eventCode = userEventCode || currentUser?.eventCode;
      
      if (data.isGroupChat && data.groupInfo?.members) {
        // Update for all group members using event-specific userChats
        for (const member of data.groupInfo.members) {
          const memberChatId = `${member.uid}_${eventCode}`;
          
          // Try event-specific format first
          try {
            await updateDoc(doc(db, "userChats", memberChatId), {
              [data.chatId + ".lastMessage"]: {
                text: messageText,
              },
              [data.chatId + ".date"]: serverTimestamp(),
            });
          } catch (error) {
            // Fallback to old format
            await updateDoc(doc(db, "userChats", member.uid), {
              [data.chatId + ".lastMessage"]: {
                text: messageText,
              },
              [data.chatId + ".date"]: serverTimestamp(),
            });
          }
        }
      } else {
        // Update for 1-on-1 chat using event-specific format
        const currentUserChatId = `${currentUser.uid}_${eventCode}`;
        const otherUserChatId = `${data.user.uid}_${eventCode}`;
        
        try {
          // Try event-specific format first
          await updateDoc(doc(db, "userChats", currentUserChatId), {
            [data.chatId + ".lastMessage"]: {
              text: messageText,
            },
            [data.chatId + ".date"]: serverTimestamp(),
          });

          await updateDoc(doc(db, "userChats", otherUserChatId), {
            [data.chatId + ".lastMessage"]: {
              text: messageText,
            },
            [data.chatId + ".date"]: serverTimestamp(),
          });
        } catch (error) {
          // Fallback to old format
          await updateDoc(doc(db, "userChats", currentUser.uid), {
            [data.chatId + ".lastMessage"]: {
              text: messageText,
            },
            [data.chatId + ".date"]: serverTimestamp(),
          });

          await updateDoc(doc(db, "userChats", data.user.uid), {
            [data.chatId + ".lastMessage"]: {
              text: messageText,
            },
            [data.chatId + ".date"]: serverTimestamp(),
          });
        }
      }
    } catch (error) {
      console.error("Update last message error:", error);
    }
  };
  return (
    <div className="input">
      <input
        type="text"
        placeholder="Type something..."
        onChange={(e) => setText(e.target.value)}
        value={text}
      />
      <div className="send">
        <img src={Attach} alt="" />
        <input
          type="file"
          style={{ display: "none" }}
          id="file"
          onChange={(e) => setImg(e.target.files[0])}
        />
        <label htmlFor="file">
          <img src={Img} alt="" />
        </label>
        <button onClick={handleSend}>Send</button>
      </div>
    </div>
  );
};

export default Input;
